module.exports = __webpack_public_path__ + "static/media/icon_investment-anlegerin.666ad96e.svg";